<template>
    <div id="MapDetails">
        <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item @click.native="$router.go(-1)">活动管理</el-breadcrumb-item>
                <el-breadcrumb-item>活动列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="map-content">
            <div class="map" id="map"></div>
            <div class="map-info">
                <div class="map-info-title">{{params.name}}</div>
                <p>地址：{{params.address}}</p>
                <p>类型：{{params.type}}</p>
                <p>
                    电话：{{params.phone_number}}
                    <img src="../../assets/img/问号.png" alt="">
                </p>
                <p>
                    收费:
                    <span class="charge">¥{{params.charge}}</span>
                </p>
                <div class="confirm-info">
                    <span @click="addLove('去过')">
                        <img :src="info.go ? go.select : go.normal" alt="">
                        222人去过
                    </span>
                    <span @click="addLove('收藏')">
                        <img :src="info.collection ? collection.select : collection.normal" alt="">
                        222人喜欢
                    </span>
                </div>
            </div>
        </div>
        <div class="black-title">钓点详情</div>
        <div class="line"></div>
        <div class="details">
            <div>
                <span>钓点类型</span>
                <span>{{params.type}}</span>
            </div>
            <div>
                <span>交通工具</span>
                <span>{{params.transport}}</span>
            </div>
            <div>
                <span>鱼类分布</span>
                <span>{{params.fishes}}</span>
            </div>
        </div>
        <div class="black-title">钓友评论 <span>(四条评价)</span></div>
        <div class="line"></div>
        <div class="comment-item">
            <div class="user-info">
                <el-avatar :src="img"></el-avatar>
                <div class="user-name">
                    <p>游客汤姆</p>
                    <p>2020-1-20</p>
                </div>
            </div>
            <div class="comment-content">
                海钓鱼频道直播 快乐垂钓频道直播 四海钓鱼频道是一档非常精彩的节目，虽然经常莫名其妙插播广告遭到很多吐槽，不过节目中播放的背景音乐、歌曲都吸引很多人耳朵。
            </div>
            <div class="line"></div>
        </div>
        <div class="comment-item">
            <div class="user-info">
                <el-avatar :src="img"></el-avatar>
                <div class="user-name">
                    <p>游客汤姆</p>
                    <p>2020-1-20</p>
                </div>
            </div>
            <div class="comment-content">
                海钓鱼频道直播 快乐垂钓频道直播 四海钓鱼频道是一档非常精彩的节目，虽然经常莫名其妙插播广告遭到很多吐槽，不过节目中播放的背景音乐、歌曲都吸引很多人耳朵。
            </div>
            <div class="line"></div>
        </div>
        <div class="comment-area">
            <textarea placeholder="我也想说说"></textarea>
        </div>
        <el-button type="primary" :style="{width: '100px',marginLeft: '620px'}">评论</el-button>
    </div>
</template>

<script>
    import { MP } from '../../assets/js/map.js'

    export default {
        name: 'MapDetails',
        data() {
            return {
                img: require('../../assets/img/logo示意.png'),
                // 去过
                go: {
                    normal: require('../../assets/img/去过.png'),
                    select: require('../../assets/img/已去过.png')
                },
                // 收藏
                collection: {
                    normal: require('../../assets/img/收藏.png'),
                    select: require('../../assets/img/已收藏.png')
                },
                info: {
                    go: false,
                    collection: false
                },
                // 页面得信息
                params: {}
            }
        },
        methods: {
            getMap() {
                let map = new BMap.Map('map')
                let point = new BMap.Point(122.195884, 30.179534)
                // 创建标注
                let marker = new BMap.Marker(point)
                let opts = {
                    width: 100,
                    height: 50
                    // title: 'Hello'
                }
                // 创建信息窗口对象
                let infoWindow = new BMap.InfoWindow('舟山海钓', opts)
                map.addOverlay(marker)
                map.centerAndZoom(point, 12)
                // 打开信息窗口
                map.openInfoWindow(infoWindow, map.getCenter())
                marker.addEventListener('click', function () {
                    map.openInfoWindow(infoWindow, map.getCenter())
                })
            },
            addLove(type) {
                if (type === '去过') {
                    this.info.go = !this.info.go
                } else if (type === '收藏') {
                    this.info.collection = !this.info.collection
                }
            },
            /**
             * 获得上个页面得参数
             */
            getParams() {
                this.params = this.$route.query
            }
        },
        created() {
            this.getParams()
        },
        mounted() {
            this.$nextTick(() => {
                MP().then(BMap => {
                    this.getMap()
                })
            })
        }
    }
</script>

<style scoped lang="less">
    #MapDetails {
        width: 1200px;
        margin: 0 auto;

        .breadcrumb {
            margin: 25px 0;
        }

        .map-content {
            width: 100%;
            display: flex;
            justify-content: space-between;

            #map {
                width: 720px;
                height: 400px;
            }

            .map-info {
                width: calc(100% - 780px);
                height: 400px;

                .map-info-title {
                    width: 100%;
                    height: 42px;
                    line-height: 21px;
                    font-size: 18px;
                    font-weight: bold;
                    color: rgba(34, 34, 34, 1);
                    margin: 20px 0;
                    overflow: hidden;
                }

                > p {
                    line-height: 30px;
                    height: 30px;
                    color: #666;
                }

                .charge {
                    color: #EB5541;
                    font-size: 24px;
                }

                .confirm-info {
                    margin-top: 150px;
                    display: flex;
                    justify-content: flex-start;

                    span {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        > img {
                            margin-right: 5px;
                        }

                        &:nth-of-type(2) {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }

        .black-title {
            margin-top: 50px;
            font-weight: bold;
            font-size: 18px;
            color: rgba(51, 51, 51, 1);

            > span {
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
            }
        }

        .line {
            margin-top: 10px;
            width: 720px;
            height: 1px;
            background: rgba(238, 238, 238, 1);
        }

        .details {
            > div {
                margin: 20px 0;

                span {
                    &:nth-of-type(1) {
                        color: #999;
                        margin-right: 40px;
                    }
                }
            }
        }

        .comment-item {
            width: 720px;

            .user-info {
                margin-top: 25px;
                height: 40px;
                display: flex;

                .user-name {
                    margin-left: 20px;
                    display: flex;
                    height: 40px;
                    flex-direction: column;
                    justify-content: space-around;
                }
            }

            .comment-content {
                margin: 25px 0;
                width: 100%;
                line-height: 22px;
            }
        }

        .comment-area {
            margin: 30px 0;
            width: 720px;
            height: 64px;
            padding: 10px;
            box-sizing: border-box;
            background: rgba(244, 244, 244, 1);
            > textarea {
                border: none;
                width: 100%;
                height: 100%;
                resize: none;
                background: rgba(244, 244, 244, 1);
                outline: none;
            }
        }

        /*.btn-box {*/
        /*    width: 1200px;*/
        /*}*/
    }
</style>



// WEBPACK FOOTER //
// src/views/details/MapDetails.vue